module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "nav"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "ncover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/cover#cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "ntitle-page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/title_page#title-page"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nde1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Dedication#de1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nep2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Epigraph#ep2"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('li', {
    staticClass: "tocnav",
    attrs: {
      "hidden": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nma3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Map_2#ma3"
    }
  }, [_vm._v("Map #1")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nma4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Map_3#ma4"
    }
  }, [_vm._v("Map #2")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nma5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Map_1#ma5"
    }
  }, [_vm._v("Map #3")])]), _vm._v(" "), _c('li', {
    staticClass: "tocfm",
    attrs: {
      "id": "nma6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Map_4#ma6"
    }
  }, [_vm._v("Map #4")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "npr7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Prologue#pr7"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_1_Hephaestus_Awak#ch8"
    }
  }, [_vm._v("Chapter 1: Hephaestus Awakes")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_2_From_the_Graves#ch9"
    }
  }, [_vm._v("Chapter 2: From the Graves of Eden")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter_3_Adaptation#ch10"
    }
  }, [_vm._v("Chapter 3: Adaptation")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_4_Dead_of_Night#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Dead of Night")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_5_Plum_Island_Ris#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Plum Island Rising")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_6_It_Came_from_Be#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: It Came from Beneath the Sea")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_7_Lysenko#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Lysenko")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_8_All_the_Remains#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: All That Remains")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_9_Seeing_Red#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Seeing Red")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_10_A_Meeting_with#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: A Meeting with Medusa")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_11_Secret_Wars#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Secret Wars")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_12_Codes_and_Cons#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Codes and Conspiracies")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_13_What_an_Octopu#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: What an Octopus Knows")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_14_Immortal_Sins#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Immortal Sins")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_15_Beyond_the_Spe#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Beyond the Spectrum")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_16_A_Study_in_Sca#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: A Study in Scarlet")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_17_Future_Primiti#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Future Primitive")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_18_Chains_of_Comm#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Chains of Command")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_19_Icarus#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Icarus")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nch27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter_20_Anger_Denial_A#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Anger, Denial, Acceptance")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_p",
    attrs: {
      "id": "nep28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Epilogue_The_Descent_of_M#ep28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")]), _c('ol', [_c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "npa29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_1_Yanni_The_Quest#pa29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 1: Yanni: The Quest")])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm_1",
    attrs: {
      "id": "npa30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Part_2_The_Darwin_Strain_#pa30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: The Darwin Strain: Anatomy of a Legend")])])])]), _vm._v(" "), _c('li', {
    staticClass: "tocbm",
    attrs: {
      "id": "nau31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Authors_Note_Reality_Chec#au31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nac32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Acknowledgments#ac32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nse33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Selected_Bibliography#se33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nab34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Authors#ab34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nca35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Card_Page#ca35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Bill Schutt & J. R. Finch")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nco38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright_electronic#co38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', {
    staticClass: "tocrm",
    attrs: {
      "id": "nab39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/About_the_Publisher#ab39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 69
// module chunks = 0